import { PAYMENT_SOURCE } from 'Data/payments.js'

export function getSource(source) {
  switch (source) {
    case PAYMENT_SOURCE.CORE:
      return 'Core'
    case PAYMENT_SOURCE.CASE_CLOSER:
      return 'Case Closer'
    case PAYMENT_SOURCE.APP_PAY:
      return 'Pay App'
    case PAYMENT_SOURCE.PATIENT_HUB:
      return 'Patient Hub'
    default:
      return '-'
  }
}
